var _circle, _circle2, _g, _path, _path2, _path3, _g2, _ellipse, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChristmasOtto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3667,
    cy: 56.0486,
    r: 55.5,
    fill: "#FEF2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_622_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 112,
    height: 112
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.3667,
    cy: 56.0486,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_622_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.6972 37.8051C70.605 42.7577 74.3236 42.3302 79.9288 50.2533C85.8604 58.6375 88.45 57.3056 91.1592 59.8354C93.8685 62.3652 96.2714 46.9729 85.4024 38.1546C78.4251 32.4936 68.7894 32.8525 69.6972 37.8051Z",
    fill: "#AEA075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.19 31.2628C72.9897 36.5401 79.8962 38.8632 85.5014 46.7862C91.4329 55.1705 88.3602 62.3917 91.0695 64.9214C93.7787 67.4512 99.7289 44.1125 90.08 33.9737C78.8946 22.2204 75.3902 25.9854 74.19 31.2628Z",
    fill: "#D1C394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5668 38.8051C43.659 43.7577 39.9404 43.3302 34.3352 51.2533C28.4037 59.6375 25.814 58.3056 23.1048 60.8354C20.3956 63.3652 17.9927 47.9729 28.8616 39.1546C35.839 33.4936 45.4747 33.8525 44.5668 38.8051Z",
    fill: "#AEA075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0741 32.2628C41.2743 37.5401 34.3679 39.8632 28.7627 47.7862C22.8311 56.1705 25.9038 63.3917 23.1946 65.9214C20.4853 68.4512 14.5351 45.1125 24.184 34.9737C35.3694 23.2204 38.8738 26.9854 40.0741 32.2628Z",
    fill: "#D1C294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8667 115.549C90.8667 115.549 77.8667 127.549 56.3667 127.549C36.3667 127.549 24.3667 117.049 24.3667 117.049C24.3667 99.9278 33.8667 50.0486 56.3667 50.0486C76.3667 50.0486 90.8667 98.4278 90.8667 115.549Z",
    fill: "url(#paint0_linear_622_2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2149 28.5533C15.9355 29.1193 39.0892 79.8024 41.561 84.2595C44.0329 88.7166 71.0327 88.7165 73.5303 83.8137C76.0279 78.9109 98.4943 27.9872 57.2149 28.5533Z",
    fill: "url(#paint1_linear_622_2)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_622_2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.3601,
    cy: 89.5583,
    rx: 18.6502,
    ry: 27.0742,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.48,
    cy: 100.417,
    r: 5.43359,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.3587,
    cy: 83.6492,
    r: 6.92206,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.6279,
    cy: 79.8894,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.2371,
    cy: 106.344,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.066,
    cy: 109.739,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.2896,
    cy: 71.3748,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.122,
    cy: 75.0124,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72.0102,
    cy: 70.9779,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.2468,
    cy: 76.3403,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1667,
    cy: 96.5292,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.7099,
    cy: 73.8576,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 59.6944,
    cy: 114.12,
    r: 3.88813,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 72.9754,
    cy: 102.456,
    rx: 4.54067,
    ry: 5.2327,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.1777,
    cy: 78.7556,
    r: 6.92206,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.9914,
    cy: 88.0616,
    rx: 5.34246,
    ry: 6.26226,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.2512 76.9305C57.2512 76.9305 64.4182 72.0776 64.4657 80.6807C64.4999 86.8794 61.2658 91.2361 57.2422 91.2584C53.2187 91.2806 49.9293 86.9599 49.895 80.7612C49.8498 72.5835 57.2512 76.9305 57.2512 76.9305Z",
    fill: "#C18282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2887 77.0486C57.2887 77.0486 44.0591 87.0892 43.9726 75.7011C43.9103 67.4957 49.8722 61.7069 57.2887 61.6506C64.7051 61.5943 70.7677 67.2918 70.83 75.4972C70.9122 86.3222 57.2887 77.0486 57.2887 77.0486Z",
    fill: "#AFA16E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.844 67.251C62.8655 69.3831 60.3655 72.5181 57.3417 72.5486C54.3179 72.5791 51.9155 69.4936 51.894 67.3615C51.8725 65.2293 54.3179 64.6343 57.3417 64.6038C60.3655 64.5733 62.8225 65.1189 62.844 67.251Z",
    fill: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.0009,
    cy: 79.2143,
    r: 3.95883,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 67.9307,
    cy: 79.2143,
    r: 3.95883,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.4921,
    cy: 78.1816,
    r: 2.92618,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56.9002,
    cy: 76.2881,
    r: 2.92618,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.4439,
    cy: 75.6986,
    r: 2.92618,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44.0048,
    cy: 76.7265,
    r: 2.92618,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.9248,
    cy: 77.2714,
    r: 3.4425,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.8553,
    cy: 78.1861,
    r: 2.52788,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51.9598,
    cy: 79.2129,
    r: 2.52788,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.311 55.9979C50.4437 57.9303 48.4583 56.1251 46.1729 56.282C43.8875 56.4388 42.1675 58.4984 42.0348 56.566C41.9022 54.6336 43.7194 53.9896 46.0048 53.8327C48.2902 53.6758 50.1784 54.0655 50.311 55.9979Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9257 55.9979C64.793 57.9303 66.7783 56.1251 69.0638 56.282C71.3492 56.4388 73.0692 58.4984 73.2019 56.566C73.3345 54.6336 71.5173 53.9896 69.2319 53.8327C66.9465 53.6758 65.0583 54.0655 64.9257 55.9979Z",
    fill: "#3D3D3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9737 12.3018C41.6268 9.96778 43.8597 8.43823 46.272 8.67245L56.3761 9.65352C57.7118 9.78321 58.9393 10.4444 59.7825 11.4883L75.763 31.2722C78.111 34.179 76.557 38.5404 72.9 39.3075L39.0163 46.4155C35.3443 47.1858 32.1637 43.7878 33.1747 40.1748L40.9737 12.3018Z",
    fill: "#D84B4B"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_622_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3382 28.9617C49.5583 30.7472 46.9458 30.4772 46.5476 28.5699L42.8777 10.9926C42.6129 9.7243 43.6055 8.54283 44.9004 8.58486L56.089 8.94798C57.5022 8.99385 58.4229 10.4517 57.8569 11.7475L50.3382 28.9617Z",
    fill: "#E95555"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 49.0459,
    cy: 30.1061,
    rx: 4.04646,
    ry: 4.12563,
    transform: "rotate(-11.8475 49.0459 30.1061)",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_622_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4564 45.728C30.1162 44.1064 31.155 42.5161 32.7765 42.1759L76.8473 32.9309C78.4689 32.5908 80.0592 33.6295 80.3993 35.2511L81.3187 39.6336C81.6333 41.1334 80.7614 42.6315 79.3035 43.1037C62.7402 48.4684 52.5631 51.4912 34.4934 52.6046C33.0205 52.6954 31.7057 51.6837 31.4028 50.2394L30.4564 45.728Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_622_2",
    x: 30.8218,
    y: 62.4841,
    width: 52.3131,
    height: 65.5241,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_622_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_622_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_622_2",
    x: 38.8347,
    y: 6.58377,
    width: 23.1914,
    height: 29.5779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_622_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_622_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_622_2",
    x: 26.3918,
    y: 28.8664,
    width: 58.9908,
    height: 27.7438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_622_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_622_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_622_2",
    x1: 57.6167,
    y1: 50.5486,
    x2: 57.6167,
    y2: 128.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D2A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_622_2",
    x1: 57.3667,
    y1: 28.5486,
    x2: 57.3667,
    y2: 87.5486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC9F6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristmasOtto);
export default __webpack_public_path__ + "static/media/christmas-otto.874a537d3399513a1720c659944bb17d.svg";
export { ForwardRef as ReactComponent };